import Button from '@cobliteam/ui/components/Button';
import { DrawerClose, DrawerHeader, DrawerTitle } from '@cobliteam/ui/components/Drawer';
import Stepper, { StepperStepHeader, useStepperContext } from '@cobliteam/ui/components/Stepper';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import { useEffect } from 'react';
import type { DriverDrawerStep, DriverDrawerType } from '../types';

interface StepperControllerProps {
  id: string;
}

/** Updates the stepper context accordingly to the step prop */
const StepperController = ({ id }: StepperControllerProps) => {
  const { goTo } = useStepperContext();

  useEffect(() => {
    goTo(id);
  }, [id, goTo]);

  return <></>;
};

interface DriverDrawerHeaderProps {
  type: DriverDrawerType;
  step: DriverDrawerStep;
  stepper?: boolean;
  initialStep?: DriverDrawerStep;
  goToStep: (step: DriverDrawerStep) => void;
}

const DriverDrawerHeader = ({ type = 'add', step = 'images', stepper = false, goToStep, initialStep }: DriverDrawerHeaderProps) => {
  const title = type === 'add' ? 'Adicionar motorista' : 'Editar motorista';
  const showBack = type === 'edit' && step === 'images';
  const showStepper = type === 'add' && stepper;

  return (
    <DrawerHeader>
      <DrawerTitle>
        <div className='space-y-2'>
          {showBack && !initialStep && (
            <Button startIcon={<Icon name='chevron-left' />} className='pl-0' variant='ghost' color='default' size='sm' onClick={() => goToStep('form')}>
              Voltar
            </Button>
          )}
          <Typography variant='heading-lg'>{title}</Typography>
          {showStepper && (
            <Stepper defineSteps={[{ id: 'form' }, { id: 'images' }]}>
              <StepperStepHeader />
              <StepperController id={step} />
            </Stepper>
          )}
        </div>
      </DrawerTitle>
      <DrawerClose />
    </DrawerHeader>
  );
};

export default DriverDrawerHeader;
